export const MATCH_INTRO_MS = 4000;
export const DRAG_THRESHOLD = 10;

export function isTableDrop(point, bounds) {
  return Boolean(bounds && point.x >= bounds.left && point.x <= bounds.right &&
    point.y >= bounds.top && point.y <= bounds.bottom);
}

export function canPlayCard(battle, slot, busy, remaining, intro) {
  return Boolean(battle?.status === 'ongoing' && battle.myTurn && !busy &&
    remaining > 0 && !intro && battle.me.cards.some(card => card.slot === slot && !card.used));
}
